import React, { useEffect } from "react";

export default function Modal({ open, onClose, children, title }) {
  // Prevent background scroll when open
  useEffect(() => {
    if (!open) return;
    const { body } = document;
    const prev = body.style.overflow;
    body.style.overflow = "hidden";
    return () => { body.style.overflow = prev; };
  }, [open]);

  // Close on Esc
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      aria-modal="true"
      role="dialog"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "var(--background-overlay)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      <div
        className="modal__sheet"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "min(var(--modal-max-width), 92%)",
          background: "var(--background-primary)",
          color: "var(--text-primary)",
          borderRadius: 0,
          padding: 16,
          boxShadow: "var(--shadow-xl)",
          maxHeight: "92vh",
          overflow: "auto",
          border: `1px solid var(--border-color)`,
        }}
      >
        <div
          className="modal__titlebar"
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 12,
            gap: 8,
          }}
        >
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, flex: 1, color: "var(--text-primary)" }}>
            {title || "Playback"}
          </h3>
          <button
            className="btn-icon"
            onClick={onClose}
            aria-label="Close"
            title="Close"
            style={{
              background: "transparent",
              color: "var(--text-primary)",
              border: 0,
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        </div>
        <div>{children}</div>
      </div>
    </div>
  );
}
